<template>
    <Select v-model="selected" @on-change="handleChanged" :multiple="multiple" :clearable="clearable" :placeholder="placeholder">
        <Option v-for="statusOption in statusOptions" :key="statusOption.key" :value="statusOption.key">{{ statusOption.label }}</Option>
    </Select>
</template>

<script>

export default {
  name: 'ContactStatusSelect',
  props: {
    placeholder: {
      type: String,
      default: 'Select contact status'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selected: this.$attrs.value,
      statusOptions: [
        { key: 'active', label: this.$t('contact.status_select.active') },
        { key: 'inactive', label: this.$t('contact.status_select.inactive') }
      ]
    }
  },
  methods: {
    handleChanged (value) {
      this.$emit('input', value)
    }
  },
  watch: {
    '$attrs.value' () {
      this.selected = this.$attrs.value
    }
  }
}
</script>
